// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__PpJ-s","overflowing":"ReadFullNote_overflowing__1pW5i"};